<div class="col-sm-2">
	<p>
		<label for="ora_scadenza_lbl">Ora</label>
		
<select id="ora_scadenza_lbl" [(ngModel)]="ora" class="form-control" (change)="onChange()" ngbTooltip="" triggers="manual" #t="ngbTooltip" (blur)='onBlur(t)' [disabled]="submitPending">
<option *ngFor="let option of ore" [value]="option?.label">
{{option?.label}}
</option>
</select>
	</p>
</div>
<div class="col-sm-2">
	<p>
		<label for="minuti_scadenza_lbl">Minuti</label>
<select id="minuti_scadenza_lbl" [(ngModel)]="min" class="form-control" (change)="onChange()" ngbTooltip="" triggers="manual" #t="ngbTooltip" (blur)='onBlur(t)' [disabled]="submitPending">
<option *ngFor="let option of minuti" [value]="option?.label">
{{option?.label}}
</option>
</select>
	</p>
</div>